"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.2.4'] && _();
}
catch (e) { }
